import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Programs from './Programs';

class ProgramsContainer extends Component {
	static propTypes = {
		programNames: PropTypes.array
	}

	render() {
		return (
			<div className="programs-container">
				<div className="row">
					<div className="col-xs-12">
						<Programs
							programNames={this.props.programNames}
						/>
					</div>
				</div>
			</div>
		);
	}
}
export default ProgramsContainer;



// WEBPACK FOOTER //
// ./components/programs/ProgramsContainer.js